import React from 'react';
import { Button, useNotify } from 'react-admin';
import GetAppIcon from '@mui/icons-material/GetApp';
import axiosApiInstance from 'src/api/axiosConfig';

export interface BaseDownloadButtonProps {
    pageUrl: string;
    label?: string;
    params?: Record<string, string | number | undefined>;
    filename?: string;
    dateDefaults?: {
        startDate?: string | Date;
        endDate?: string | Date;
    };
    defaultFileExtension?: string;
}

const formatDate = (input: string | Date): string => {
    const date = new Date(input);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

const BaseDownloadButton: React.FC<BaseDownloadButtonProps> = ({
    pageUrl,
    label = 'Download Report',
    params = {},
    filename,
    dateDefaults = {},
    defaultFileExtension = 'xlsx'
}) => {
    const notify = useNotify();

    const handleDownload = async () => {
        try {
            const now = new Date();
            const rawStart = dateDefaults.startDate;
            const rawEnd = dateDefaults.endDate;

            if (!rawStart || !rawEnd) {
                notify('Будь ласка, виберіть обидві дати початку і закінчення', { type: 'warning' });
                return;
            }

            const formattedStartDate = formatDate(rawStart);
            const formattedEndDate = formatDate(rawEnd && new Date(rawEnd) > now ? now : rawEnd);

            const response = await axiosApiInstance.get(`reports/${pageUrl}`, {
                params: {
                    ...params,
                    startDate: formattedStartDate,
                    endDate: formattedEndDate
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `${filename || pageUrl}_report.${defaultFileExtension}`);
            document.body.appendChild(link);
            link.click();

            if (link.parentNode) {
                link.parentNode.removeChild(link);
            }

            window.URL.revokeObjectURL(downloadUrl);
            notify('Файл завантажено успішно', { type: 'success' });
        } catch (error) {
            console.error('Помилка завантаження файлу:', error);
            notify('Помилка завантаження файлу', { type: 'error' });
        }
    };

    return <Button onClick={handleDownload} label={label} startIcon={<GetAppIcon />} />;
};

export default BaseDownloadButton;
